import styled from 'styled-components';

const ModalBackgroundStyled = styled.div`
  background: rgba(14, 20, 29, 0.85);
  height: 100vh;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 100;
`;

const MenuStyled = styled.div`
  bottom: 124px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 32px;
  justify-items: end;
  position: fixed;
  right: 16px;
  z-index: 100;

  @media (min-width: 769px) {
    bottom: 64px;
    right: 64px;
  }
`;

const ButtonStyled = styled.button`
  align-items: center;
  background: #e2e6ea;
  border: none;
  box-shadow: 0px 5px 10px 0px rgba(14, 20, 29, 0.15);
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0;
`;

const CircleButtonStyled = styled(ButtonStyled)`
  border: 6.9px solid #fff;
  border-radius: 50%;
  height: 88px;
  width: 88px;
  svg {
    max-height: 42px;
    max-width: 42px;
  }

  :hover {
    background: linear-gradient(
      180deg,
      #4e018d 0%,
      #7212e8 48.44%,
      #c348ea 100%
    );

    svg > path {
      fill: #fff;
    }
  }

  ::after {
    ${({ text }) => text && `content: '${text}';`}
    background: #fff;
    border-radius: 64px;
    bottom: -24px;
    color: #4d008c;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    padding: 4px 8px;
    position: absolute;
  }
`;

const ChipButtonStyled = styled(ButtonStyled)`
  border-radius: 56px;
  background: #fff;
  color: #4d008c;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  padding: 8px 24px;

  svg {
    height: 32px;
    margin-right: 16px;
    width: 32px;
  }
`;

const HeaderStyled = styled.span`
  color: #fff;
  text-align: right;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
`;

export {
  ModalBackgroundStyled,
  MenuStyled,
  CircleButtonStyled,
  ChipButtonStyled,
  HeaderStyled,
};
